import Css from "./style.module.scss";

import { ArrowUpRight, Check, Play } from "@phosphor-icons/react";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import Button from "nlib/ui/Button";
import Environment from "utils/Environment";
import React, { useCallback, useState } from "react";
import StripeActions from "actions/StripeActions";
import classNames from "classnames";

const FETCHING_DATA_TIMEOUT = 10000;

const { ARCADE_DEMO_URL, CALENDLY_URL } = Environment.getProcessEnvVars();

const PostSignUpNew = ({ className }) => {
  const dispatch = useDispatch();

  const { uiTexts, messages } = useSelector(getTextsData);

  const [fetchingData, setFetchingData] = useState(false);

  const [postSignUpNewDescriptionA] = messages.postSignUpNewDescription;

  const [
    postSignUpNewDemoInfoA,
    postSignUpNewDemoInfoB,
    postSignUpNewDemoInfoC
  ] = messages.postSignUpNewDemoInfo;

  const [postSignUpNewFooterA, postSignUpNewFooterB] = messages.postSignUpNewFooter;

  const postSignUpNewHighlights = messages.postSignUpNewHighlights || [];

  const [postSignUpNewPaymentCardTitle] = messages.postSignUpNewPaymentCardTitle;

  const postSignUpNewPaymentChecklist = messages.postSignUpNewPaymentChecklist || [];

  const [postSignUpNewPaymentInfoA] = messages.postSignUpNewPaymentInfo;

  const postSignUpNewSteps = messages.postSignUpNewSteps || [];

  const handleTalkToSalesButtonClick = useCallback(() => {
    window.location.href = CALENDLY_URL;
  }, []);

  const handleAddPaymentMethodButtonClick = useCallback(() => {
    setFetchingData(true);
    setTimeout(() => {
      setFetchingData(false);
    }, FETCHING_DATA_TIMEOUT);
    dispatch(StripeActions.createSetupCheckoutSession()).then((sessionUrl) => {
      window.location.href = sessionUrl;
    });
  }, [dispatch]);

  return (
    <div className={classNames(Css.postSignUpNew, className)}>
      <div className={Css.content}>
        <div className={Css.card}>
          <div className={Css.block}>
            <div className={Css.description}>
              <div className={Css.title}>{postSignUpNewDescriptionA}</div>
              <div className={Css.steps}>
                {postSignUpNewSteps.map((step, index) => {
                  return (
                    <div key={step} className={Css.step}>
                      <div className={Css.stepIndex}>{index + 1}</div>
                      <span>{step}</span>
                    </div>
                  );
                })}
              </div>
              <div className={Css.highlights}>
                {postSignUpNewHighlights.map((item) => {
                  return (
                    <div key={item} className={Css.highlight}>
                      <Check weight="bold" />
                      <span>{item}</span>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={Css.row}>
              <div className={classNames(Css.col, Css.demoCol)}>
                <h6>{postSignUpNewDemoInfoA}</h6>
                <a
                  className={Css.demoPreviewLink}
                  href={ARCADE_DEMO_URL}
                  target="_blank"
                  rel="noreferrer">
                  <div className={Css.demoPreview}>
                    <div className={Css.demoBrowser}>
                      <span />
                      <span />
                      <span />
                    </div>
                    <div className={Css.demoPreviewContent}>
                      <div className={Css.demoLines}>
                        <span />
                        <span />
                        <span />
                        <span />
                      </div>
                      <div className={Css.demoCta}>
                        <Play weight="fill" />
                        <span>{postSignUpNewDemoInfoC}</span>
                      </div>
                      <div className={Css.demoGrid}>
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                        <span />
                      </div>
                    </div>
                  </div>
                </a>
                <p>{postSignUpNewDemoInfoB}</p>
              </div>
              <div className={classNames(Css.col, Css.paymentCol)}>
                <h6>{postSignUpNewPaymentCardTitle}</h6>
                <p>{postSignUpNewPaymentInfoA}</p>
                <Button
                  large
                  primary
                  disabled={fetchingData}
                  className={classNames(Css.button, Css.paymentButton)}
                  onClick={handleAddPaymentMethodButtonClick}>
                  {fetchingData ? `${uiTexts.redirectingPleaseWait}...` : uiTexts.addPaymentMethod}
                </Button>
                <div className={Css.checkList}>
                  {postSignUpNewPaymentChecklist.map((item) => {
                    return (
                      <div key={item} className={Css.checkListItem}>
                        <Check weight="bold" />
                        <span>{item}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className={Css.footer}>
              <span>{postSignUpNewFooterA}</span>
              <button
                type="button"
                className={Css.footerLink}
                onClick={handleTalkToSalesButtonClick}>
                <span>{postSignUpNewFooterB}</span>
                <ArrowUpRight />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PostSignUpNew);
